module.exports = __webpack_public_path__ + "assets/img/40@3x.e5278e64.png";